import { DocumentUploadResultMessage } from '@monorepo/shared/componentsV2/documents/DocumentUploadResultMessage';
import { ToastProps } from '@monorepo/shared/components/Toast';
import {
  DocumentBulkUploadResult,
  getDocumentUploadToastStatus,
} from '@monorepo/shared/utils/documentUpload';
import React from 'react';

type ToastMessage = ToastProps['message'];

type DocumentUploadToasts = {
  error: (message: ToastMessage) => void;
  success: (message: ToastMessage) => void;
  warning: (message: ToastMessage) => void;
};

export function showDocumentUploadToast(
  rejectedMessages: string[],
  uploadResult: DocumentBulkUploadResult,
  toasts: DocumentUploadToasts,
): void {
  const toast = getDocumentUploadToastStatus(rejectedMessages, uploadResult);
  if (!toast) return;

  const message: ToastMessage =
    rejectedMessages.length > 0 || uploadResult.failures.length > 0 ? (
      <DocumentUploadResultMessage
        rejectedMessages={rejectedMessages}
        uploadResult={uploadResult}
      />
    ) : (
      toast.message
    );

  toasts[toast.status](message);
}
